import { TooltipStyled } from './styled'

const Tooltip = ({
  children,
  title,
  placement = 'top',
  offset = 8,
  disabled = false,
  arrow = true,
  describeChild = true,
  PopperProps,
  ...rest
}) => {
  if (disabled) {
    return children
  }

  const modifiers = [
    ...(PopperProps?.modifiers || []).filter(({ name }) => name !== 'offset'),
    {
      name: 'offset',
      options: {
        offset: [0, offset],
      },
    },
  ]

  return (
    <TooltipStyled
      {...rest}
      title={title}
      placement={placement}
      arrow={arrow}
      describeChild={describeChild}
      PopperProps={{
        ...PopperProps,
        modifiers,
      }}
    >
      {children}
    </TooltipStyled>
  )
}

export { Tooltip }
